import { Form, InputNumber, Select, Card, Row, Col, Switch, Input, Spin } from "antd";
import { FormInstance } from "antd/lib/form";

export interface Tax {
    id: number;
    taxType: string;
    rate: number;
    isActive: boolean;
}

export interface TaxOption {
    label: string;
    value: number;
    data: Tax;
}

interface TaxInfoCardProps {
    form: FormInstance;
    taxOptions: TaxOption[];
    handleTaxSelect: (value: string) => void;
    isLoading?: boolean;
}

export const TaxInfoCard = ({ form, taxOptions, handleTaxSelect, isLoading = false }: TaxInfoCardProps) => {
    return (
        <Card title="Tax Information" style={{ marginBottom: 16 }}>
            <Row gutter={16}>
                <Col span="24">
                    <Form.Item
                        label="Select Tax"
                        name="TaxId"
                        rules={[{ required: true, message: "Please select a tax" }]}
                    >
                        <Select
                            placeholder={isLoading ? "Loading taxes..." : "Select a tax type"}
                            style={{ width: '100%' }}
                            onChange={handleTaxSelect}
                            options={taxOptions}
                            disabled={isLoading}
                            loading={isLoading}
                            notFoundContent={isLoading ? <Spin size="small" /> : "No taxes found"}
                        />
                    </Form.Item>
                </Col>
            </Row>

            {/* Hidden fields to store tax data */}
            <Row gutter={16}>
                <Col span="8">
                    <Form.Item
                        label="Tax Type"
                        name={['Tax', 'TaxType']}
                        hidden
                    >
                        <Input id="taxType" />
                    </Form.Item>
                </Col>

                <Col span="8">
                    <Form.Item
                        label="Tax Rate (%)"
                        name={['Tax', 'Rate']}
                        hidden
                    >
                        <InputNumber
                            id="taxRate"
                            min={0}
                            max={100}
                            precision={2}
                        />
                    </Form.Item>
                </Col>

                <Col span="8">
                    <Form.Item
                        label="Tax Is Active"
                        name={['Tax', 'IsActive']}
                        hidden
                        valuePropName="checked"
                    >
                        <Switch id="taxActive" />
                    </Form.Item>
                </Col>
            </Row>
        </Card>
    );
};